<template>
    <div class="setting" v-show="show">
        <div class="setting__label">{{getLabel}}</div>
        <div class="setting__option setting__plusmin" id="set-flow-air">
            <span class="setting__plusmin">
                <span class="sub" @click.prevent="sub()">-</span>
                <input id="ref-set-flow" type="number" min="0" max="1000" :class="isExceedingLimitations" :value="item.value | Rounder" step=".1" @keyup.enter.prevent="$event.target.blur()" @focus.prevent="onFocus(index,$event)" @blur.prevent="onBlur(index,$event)">
                <span class="add" @click.prevent="add()">+</span>
            </span>
        </div>
        <div class="setting__option setting__unit">{{$t(converterType)}}</div>
    </div>
</template>

<script>
import { EventBus } from "./../../event-bus.js";
import converter from "./../../convert.service";
import Vue from "vue";

export default {
  name: "inputComponent",
  props: ["item", "index" , 'Limitations','inputType','plugindataInput'],
  data() {
    return {
      title: null,
      settings: this.$store.state.settings,
			show: true,
			interval : .1
    };
  },
  methods: {
    selectItem() {
      this.tech.selected = !this.tech.selected;
      this.$emit("unit-clicked", this);
    },
    sub() {
      this.item.value -= this.interval;
      EventBus.$emit("updateCalculation");
    },
    add() {
      this.item.value += this.interval;
      EventBus.$emit("updateCalculation");
    },
    onFocus(index, e) {
      console.log("onFocus:" + this.item.inputParam);
      if (navigator.userAgent.match(/Edge\/(13|14)/)) {
        return setTimeout(e.target.select.bind(e.target), 10);
      } else {
        e.target.select();
      }
    },
    onBlur(index, e) {
      console.log(this.item.inputParam + " onBlur:" + e.target.value);
      this.item.value = parseFloat(e.target.value);
      this.checkLimitations();
      EventBus.$emit("updateCalculation");
    },
    checkLimitations(){

      //console.log('\n');
      
      let limits = this.Limitations[this.inputType];
      let ExceedsLimits = false;

      if(this.item.name === 'Delta T')
        return '';
      
      switch (this.item.inputParam) {
        case 'Temperature':
          let tempKevin = converter.toKelvin(this.settings[this.item.inputParam].selected,this.item.value);
          // console.log('inputType',this.inputType);
          // console.log('inputParam',this.item.inputParam);
          // console.log(this.inputType,' Limitations Temperature:',limits.Temperature_Min,tempKevin,limits.Temperature_Max,this.item.value,this.settings[this.item.inputParam].selected);
             
          if(tempKevin > limits.Temperature_Max )
            ExceedsLimits = true;
          if(tempKevin < limits.Temperature_Min )
            ExceedsLimits = true;
             
          
          break;

        case 'Pressure':
          let pressPA = converter.toPascal(this.settings[this.item.inputParam].selected,this.item.value)
          // console.log('inputType',this.inputType);
          // console.log('inputParam',this.item.inputParam);
          // console.log(this.inputType,' Limitations Pressure:',limits.Pressure_Min,pressPA,limits.Pressure_Max ,this.item.value );
          
           if(this.plugindataInput)
            if(this.plugindataInput.Reference)
            {
              if(pressPA > (limits.Pressure_Max - this.plugindataInput.Reference.Pressure) )
                ExceedsLimits = true;
              if(pressPA < (limits.Pressure_Min - this.plugindataInput.Reference.Pressure) )
                ExceedsLimits = true;
            }

          break;
      }

      return (ExceedsLimits) ? 'ExceedingLimitations' : '';
    }
  },
  computed: {
    isExceedingLimitations(){
      
      return this.checkLimitations() ;
    },
    getLabel() {
      let res = this.item.name;
      let CoolingWaterInput = this.settings.CoolingWaterInput.selected;

      if (this.item.inputParam === "CoolingWaterflow" || res === "Delta T") {
        let show = false;
        if (res === "Delta T" && CoolingWaterInput === 1) show = true;
        if (
          this.item.inputParam === "CoolingWaterflow" &&
          CoolingWaterInput === 0
        )
          show = true;

        this.show = show;
      }
      //console.log('getLabel');
      return Vue.i18n.translate(res);
    },
    converterType() {
      let param = this.settings[this.item.inputParam];
      // console.log(
      //   this.item.inputParam +
      //     " from:" +
      //     this.prevIndex +
      //     " to:" +
      //     param.selected
      // );
      //convert item.value

      if (this.prevIndex !== undefined) {
        switch (this.item.inputParam) {
          case "CompressedAirFlow":
            this.item.value = converter.Flow(
              this.prevIndex,
              param.selected,
              this.item.value
            );
            break;
          case "Temperature":
            //special conversion for DeltaT temperature
            if (this.item.name === "Delta T")
              this.item.value = converter.TemperatureDelta(
                this.prevIndex,
                param.selected,
                this.item.value
              );
            else
              this.item.value = converter.Temperature(
                this.prevIndex,
                param.selected,
                this.item.value
              );
            break;
          case "Pressure":
            this.item.value = converter.Pressure(
              this.prevIndex,
            	param.selected,
              this.item.value
            );
            break;
          case "CoolingWaterflow":
            this.item.value = converter.CoolingWaterFlow(
              this.prevIndex,
              param.selected,
              this.item.value
            );
            break;
        }
      }
      this.prevIndex = param.selected;
      const converterAddon = this.item.inputParam === "Pressure" ? "(g)" : "";
      return param.items[param.selected].name + converterAddon;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
    });
  }
};
</script>

<style lang="css" scoped >
.ExceedingLimitations{
  color :rgb(255, 108, 108);
}
</style>


// WEBPACK FOOTER //
// SettingInput.vue?2263b51f